"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibleDatePickerButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = require("../../button");

var _icons = require("../../icons");

var _responsive = require("../../responsive");

var _screenReaderOnly = require("../../screen-reader-only");

var _utils = require("../../utils");

var _helperComponents = require("../helperComponents");

var _core = require("@emotion/core");

var AccessibleDatePickerButton = function AccessibleDatePickerButton(_ref) {
  var isOpen = _ref.isOpen,
      calendarButtonAltText = _ref.calendarButtonAltText,
      iconColor = _ref.iconColor,
      toggle = _ref.toggle;

  var _useBreakpoints = (0, _responsive.useBreakpoints)(),
      matches = _useBreakpoints.matches;

  var dialogueId = (0, _utils.getUniqueId)('AccessibleDatePickerButton');
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_helperComponents.DatePickerButton, {
    icon: (0, _core.jsx)(_icons.IconCalendar, {
      title: calendarButtonAltText,
      color: iconColor
    }),
    iconColor: iconColor,
    onClick: toggle,
    size: _button.ButtonSize.Small,
    variant: _button.ButtonVariant.Tertiary,
    "aria-expanded": matches.s ? undefined : isOpen,
    "aria-describedby": matches.s ? dialogueId : undefined
  }), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    id: dialogueId
  }, "has pop up dialog"));
};

exports.AccessibleDatePickerButton = AccessibleDatePickerButton;